<template>
  <resize-table
    :columns="columns"
    bordered
    :scroll="{ x:0, y: 450 }"
    :data-source="list"
    row-key="id"
    :pagination="false"
    class="noTh"
    :rowClassName="rowClassName"
  >
    <span slot="fixed3" slot-scope="text">
      {{ (text || text === 0) && (Number(text) || Number(text) === 0) ? Number(text).toFixed(len) : text }}
    </span>
  </resize-table>
</template>

<script>
export default {
  props: ['list','ArrLen'],
  data() {
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      len: 3,
    }
  },
  computed: {
    columns(){
      let lst = []
      Array.from({length: this.ArrLen || 6},(e,i) => {
        let obj = {
          dataIndex: `v${i + 1}`,
          title: '',
          width: 100,
        }
        if(i >= 2) obj.scopedSlots = {customRender: 'fixed3'}
        lst.push(obj)
      })
      return lst
    },
  },
  methods: {
    rowClassName(record){
      let className = ''
      let {v1} = record || {}
      if(v1 === '原料名称') className = 'titleStyle'
      // if(v7 == '1' && v9 == '1') className = 'selectGary'
      let arrLen = Object.keys(record).length
      if(arrLen > 0) {
        let isDeleted = record[`v${arrLen - 2}`],
        isRawDelete = record[`v${arrLen - 1}`],
        isExtraProRaw = record[`v${arrLen}`],
        v1 = record.v1
        // if(isRawDelete == 1 || (isExtraProRaw == 1 && isDeleted == 1) || v1 == '合计') className = 'selectGary'
        if(isRawDelete === '1' || (isExtraProRaw === '1' && isDeleted === '1') || v1 == '合计') className = 'selectGary'
      }
      return className
    }
  }
}
</script>


<style lang="scss">
  .noTh{
    .ant-table-thead > tr > th{
      display: none;
    }
    .titleStyle{
      background-color: #f6f6f6;
    }
  }
</style>
<style lang="scss" scoped>
::v-deep .selectRows{
  background-color: rgba(255, 206, 163, 0.1) !important;
  background-color:#fff9e5 !important;
}
::v-deep .selectGary{
  background-color: rgba(130, 130, 130, 0.1) !important;
}
</style>